import { BrowserRouter, Route, Routes, Outlet, Navigate, useLocation, useParams } from 'react-router-dom';
import { lazy, Suspense } from "react";
import ScrollToTop2 from "react-scroll-to-top";

//layouts
import Header from './../layouts/Header';
import Footer from './../layouts/Footer';
import ScrollToTop from './../layouts/ScrollToTop';

//Pages
import Home from './Home';

import logo from './../assets/images/background/artTokri_logo.webp';
import BottomNav from '../components/BottomNav';
// import BuyUniqueHandmadeProductsStudentEntrepreneursDelhi from './BuyhandmadeProductsCreatedByStudentsInDelhi';
// import BuyhandmadeProductsCreatedByStudentsInDelhi from './BuyhandmadeProductsCreatedByStudentsInDelhi';
// const Home2 = lazy(() => import('./Home2'));
const MyProfile = lazy(() => import('./MyProfile'));
const Student_profile = lazy(() => import('./StudentProfile'));
const Faq = lazy(() => import('./Faq'));
const Impact = lazy(() => import('./impact'));
const HelpDesk = lazy(() => import('./HelpDesk'));
const Pricing = lazy(() => import('./Pricing'));
const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));
const TermsAndCondition = lazy(() => import('./TermsAndCondition'));
const SavedAddress = lazy(() => import('./SavedAddress'));
const ShopList = lazy(() => import('./ShopList'));
const BooksGridViewSidebar = lazy(() => import('./BooksGridViewSidebar'));
const BooksListViewSidebar = lazy(() => import('./BooksListViewSidebar'));
const ShopCart = lazy(() => import('./ShopCart'));
const MyOrders = lazy(() => import('./MyOrders'));
const Wishlist = lazy(() => import('./Wishlist'));
const Login = lazy(() => import('./Login'));
const Registration = lazy(() => import('./Registration'));
const OtpVerification = lazy(() => import('./OtpVerification'));
const ShopCheckout = lazy(() => import('./ShopCheckout'));
const ShopDetail = lazy(() => import('./ShopDetail'));
const BlogGrid = lazy(() => import('./BlogGrid'));
const BlogLargeSidebar = lazy(() => import('./BlogLargeSidebar'));
const BlogListSidebar = lazy(() => import('./BlogListSidebar'));
const BlogDetail = lazy(() => import('./BlogDetail'));
const ContactUs = lazy(() => import('./ContactUs'));


// const ErrorPage = lazy(() => import('./ErrorPage'));
// const UnderConstruction = lazy(() => import('./UnderConstruction'));
// const ComingSoon = lazy(() => import('./ComingSoon'));


//images
const StudentEntrepreneurshipPune = lazy(() => import('./StudentEntrepreneurshipPune'));
const StudentCreativityEntrepreneurshipDelhi = lazy(() => import('./StudentCreativityEntrepreneurshipDelhi'));
const RefundAndCancellation = lazy(() => import('./RefundAndCancellation'));
const ShippingAndDelivery = lazy(() => import('./ShippingAndDelivery'));
const AllStudents = lazy(() => import('./AllStudents'));
const AllTestimonials = lazy(() => import('./AllTestimonials'));
const AllBlogs = lazy(() => import('./AllBlogs'));
const EmailOtpVerification = lazy(() => import('./EmailOtpVerification'));
const StudentEntrepreneurshipBengaluru = lazy(() => import('./StudentEntrepreneurshipBengaluru'));
const StudentEntrepreneurshipUSA = lazy(() => import('./StudentEntrepreneurshipUSA'));
const StudentEntrepreneurshipCanada = lazy(() => import('./StudentEntrepreneurshipCanada'));
const StudentEntrepreneurshipUK = lazy(() => import('./StudentEntrepreneurshipUK'));
const StudentEntrepreneurshipAustralia = lazy(() => import('./StudentEntrepreneurshipAustralia'));
const StudentEntrepreneurshipGermany = lazy(() => import('./StudentEntrepreneurshipGermany'));
const StudentEntrepreneurshipIndia = lazy(() => import('./StudentEntrepreneurshipIndia'));
const FollowList = lazy(() => import('./FollowList'));
const YouTubeGallery = lazy(() => import('./YouTubeGallery'));
const BuyHandmadePaintingsOnlineStudentArt = lazy(() => import('./BuyHandmadePaintingsOnlineStudentArt'));
const LuxuryDigitalArtPrintsForModernHomeAndOfficeDecor = lazy(() => import('./LuxuryDigitalArtPrintsForModernHomeAndOfficeDecor'));
const HandmadeWallArtForLivingRoom = lazy(() => import('./HandmadeWallArtForLivingRoom'));
const HandmadeCanvasPaintingsForModernHomes = lazy(() => import('./HandmadeCanvasPaintingsForModernHomes'));
const LuxuryHandmadeSculpturesHomeDecor = lazy(() => import('./LuxuryHandmadeSculpturesHomeDecor'));
const StudentProfile = lazy(() => import('./StudentProfile'));
const HandmadeHomeDecor = lazy(() => import('./HandmadeHomeDecor'));
const HandmadeLifestyleProducts = lazy(() => import('./HandmadeLifestyleProducts'));
const HandmadeApparelOnline = lazy(() => import('./HandmadeApparelOnline'));
const HandmadeDrawings = lazy(() => import('./HandmadeDrawings'));
const HandmadeDrinkwareOnline = lazy(() => import('./HandmadeDrinkwareOnline'));
const AnimeArt = lazy(() => import('./AnimeArt'));
const ArtForHomeDecor = lazy(() => import('./ArtForHomeDecor'));
const HandmadeFestivalDecor = lazy(() => import('./HandmadeFestivalDecor'));
const CustomRequestForm = lazy(() => import('./CustomRequestForm'));
const MyRequests = lazy(() => import('./MyRequests'));
const HandmadeGiftsOnlineForEveryOccasion = lazy(() => import('./HandmadeGiftsOnlineForEveryOccasion'));
const LuxuryPrintableWallArt = lazy(() => import('./LuxuryPrintableWallArt'));
const ModernDigitalArtworkDecor = lazy(() => import('./ModernDigitalArtworkDecor'));
const PersonalizedGiftItems = lazy(() => import('./PersonalizedGiftItems'));
const ModernCanvasWallArtStylishInteriors = lazy(() => import('./ModernCanvasWallArtStylishInteriors'));
const HandmadeHomeDecorIdeas = lazy(() => import('./HandmadeHomeDecorIdeas'));
const UniqueHomeAndLivingProducts = lazy(() => import('./UniqueHomeAndLivingProducts'));
const ModernSculpturesForHomeDecor = lazy(() => import('./ModernSculpturesForHomeDecor'));
const BestHandmadeSiftsInPune = lazy(() => import('./BestHandmadeSiftsInPune'));
const BuyHandmadeGiftsOnlineInPune = lazy(() => import('./BuyHandmadeGiftsOnlineInPune'));
const Accounts = lazy(() => import('./Accounts'));
const TopRatedHandmadeGiftShopInPune = lazy(() => import('./TopRatedHandmadeGiftShopInPune'));
const AffordableHandmadeGiftsInPuneHomeDelivery = lazy(() => import('./AffordableHandmadeGiftsInPuneHomeDelivery'));
const ExclusiveHandmadeGiftsInPuneOnline = lazy(() => import('./ExclusiveHandmadeGiftsInPuneOnline'));
const BuyHandmadeProductsbyDelhiStudentsOnline = lazy(() => import('./BuyHandmadeProductsbyDelhiStudentsOnline'));
const BuyhandmadeProductsCreatedByStudentsInDelhi = lazy(() => import('./BuyhandmadeProductsCreatedByStudentsInDelhi'));
const BuyUniqueHandmadeProductsStudentEntrepreneursDelhi = lazy(() => import('./BuyUniqueHandmadeProductsStudentEntrepreneursDelhi'));
const HandcraftedGiftsDelhi = lazy(() => import('./HandcraftedGiftsDelhi'));
const StudentHandmadeArtGiftsDecorDelhi = lazy(() => import('./StudentHandmadeArtGiftsDecorDelhi'));
const HandmadeProductsOnlineShoppingIndia = lazy(() => import('./HandmadeProductsOnlineShoppingIndia'));
const DiscoverBeautifulHandmadeProductsOnline = lazy(() => import('./DiscoverBeautifulHandmadeProductsOnline'));
const HandmadePurchaseHelpsStudentEntrepreneurs = lazy(() => import('./HandmadePurchaseHelpsStudentEntrepreneurs'));
const HandmadeStoreOnline = lazy(() => import('./HandmadeStoreOnline'));
const AffordableModernSculpturesforStylishHomeDecor = lazy(() => import('./AffordableModernSculpturesforStylishHomeDecor'));
const BuyHandmadeProductsinPune = lazy(() => import('./BuyHandmadeProductsinPune'));
const PrintableWallArtBedroomDecoration = lazy(() => import('./PrintableWallArtBedroomDecoration'));
const BuyPremiumHandmadeGiftsinPune = lazy(() => import('./BuyPremiumHandmadeGiftsinPune'));
const HandmadeProductsinPune = lazy(() => import('./HandmadeProductsinPune'));
const EcoFriendlyHandmadeProductsPune = lazy(() => import('./EcoFriendlyHandmadeProductsPune'));
const BuyHandmadeDecorativeItemsPune = lazy(() => import('./BuyHandmadeDecorativeItemsPune'));
const BeautifulHandmadeProductsPune = lazy(() => import('./BeautifulHandmadeProductsPune'));
const HandmadeHomeDecorProductsPune = lazy(() => import('./HandmadeHomeDecorProductsPune'));
const AuthenticHandmadeProductsOnlinePune = lazy(() => import('./AuthenticHandmadeProductsOnlinePune'));
const ShopHandmadeProductsOnlinePune = lazy(() => import('./ShopHandmadeProductsOnlinePune'));
const BestPlaceBuyHandmadeProductsPune = lazy(() => import('./BestPlaceBuyHandmadeProductsPune'));
const BuyHandmadeKundanRakhiOnline = lazy(() => import('./BuyHandmadeKundanRakhiOnline'));
const AnimeArtHandmadePaintingsWallArtStudentCreations = lazy(() => import('./AnimeArtHandmadePaintingsWallArtStudentCreations'));
const GiftingStationeryOnlineIndia = lazy(() => import('./GiftingStationeryOnlineIndia'));
const HandmadePaintingGermanyNearMe = lazy(() => import('./HandmadePaintingGermanyNearMe'));
const SketchDrawingOnline = lazy(() => import('./SketchDrawingOnline'));
const BestBagsAccessoriesWomenMenEverydayUse = lazy(() => import('./BestBagsAccessoriesWomenMenEverydayUse'));
const BuyPremiumHealthyWaterBottle = lazy(() => import('./BuyPremiumHealthyWaterBottle'));
const SketchArtistInPuneHandmadePortraitFromPhoto = lazy(() => import('./SketchArtistInPuneHandmadePortraitFromPhoto'));
const BestSketchArtistInBengaluruCustomHandmadePortraits = lazy(() => import('./BestSketchArtistInBengaluruCustomHandmadePortraits'));
const HandmadePortraitFromPhotoInDelhi = lazy(() => import('./HandmadePortraitFromPhotoInDelhi'));
const HireSketchArtistUsaHandmadePortraits = lazy(() => import('./HireSketchArtistUsaHandmadePortraits'));
const BuyHandmadeProductsCanadaOnline = lazy(() => import('./BuyHandmadeProductsCanadaOnline'));
const HandmadeProductsInCanada = lazy(() => import('./HandmadeProductsInCanada'));
const BuyHandmadeProductsInGermanyOnline = lazy(() => import('./BuyHandmadeProductsInGermanyOnline'));
const ShopHandmadeIndianProductsOnlineInGermany = lazy(() => import('./ShopHandmadeIndianProductsOnlineInGermany'));
const DiscoverHandmadeProductsGermany = lazy(() => import('./DiscoverHandmadeProductsGermany'));
const WhereToBuyHandmadeProductsGermany = lazy(() => import('./WhereToBuyHandmadeProductsGermany'));
const BestHandmadeProductsGermany = lazy(() => import('./BestHandmadeProductsGermany'));
const DigitalArtGermany = lazy(() => import('./DigitalArtGermany'));
const UniqueHandmadeGiftIdeasForBirthdays = lazy(() => import('./UniqueHandmadeGiftIdeasForBirthdays'));
const AustralianHandmadeProducts = lazy(() => import('./AustralianHandmadeProducts'));
const BestAustralianHandmadeProductsOnline = lazy(() => import('./BestAustralianHandmadeProductsOnline'));
const BuyAustralianHandmadeProductsOnline = lazy(() => import('./BuyAustralianHandmadeProductsOnline'));
const ShopAustralianHandmadeProductsOnline = lazy(() => import('./ShopAustralianHandmadeProductsOnline'));
const DiscoverAustralianHandmadeProductsOnline = lazy(() => import('./DiscoverAustralianHandmadeProductsOnline'));
const BuyHandmadeProductsInBengaluru = lazy(() => import('./BuyHandmadeProductsInBengaluru'));
const UniqueDigitalArtBengaluruOnline = lazy(() => import('./UniqueDigitalArtBengaluruOnline'));
const BengaluruHandcraftedShopping = lazy(() => import('./BengaluruHandcraftedShopping'));
const UniqueDigitalArtBengaluru = lazy(() => import('./UniqueDigitalArtBengaluru'));
const FestivalDecorBengaluru = lazy(() => import('./FestivalDecorBengaluru'));
const BengaluruFestivalDecorShopping = lazy(() => import('./BengaluruFestivalDecorShopping'));
const DiyHandmadeProductsInBengaluru = lazy(() => import('./DiyHandmadeProductsInBengaluru'));
const DiyHandmadeCraftsBengaluruOnline = lazy(() => import('./DiyHandmadeCraftsBengaluruOnline'));
const CustomPersonalizedProductsBengaluru = lazy(() => import('./CustomPersonalizedProductsBengaluru'));
const PersonalizedGiftsBengaluruOnline = lazy(() => import('./PersonalizedGiftsBengaluruOnline'));
const CanvasPaintingsBengaluruOnline = lazy(() => import('./CanvasPaintingsBengaluruOnline'));
const HandmadeBagsAccessoriesbengaluru = lazy(() => import('./HandmadeBagsAccessoriesbengaluru'));
const CanvasPaintingsInBengaluru = lazy(() => import('./CanvasPaintingsInBengaluru'));
const BengaluruHandmadeBagsAccessoriesOnline = lazy(() => import('./BengaluruHandmadeBagsAccessoriesOnline'));
const BuyArtHomeBengaluruOnline = lazy(() => import('./BuyArtHomeBengaluruOnline'));
const ShopArtHomeBengaluru = lazy(() => import('./ShopArtHomeBengaluru'));
const BuyHandmadeApparelBengaluruOnline = lazy(() => import('./BuyHandmadeApparelBengaluruOnline'));
const ShopHandmadeApparelBengaluru = lazy(() => import('./ShopHandmadeApparelBengaluru'));
const BuyAnimeArtBengaluruOnline = lazy(() => import('./BuyAnimeArtBengaluruOnline'));
const ShopAnimeArtBengaluru = lazy(() => import('./ShopAnimeArtBengaluru'));
const BuyHandmadeSketchOnline = lazy(() => import('./BuyHandmadeSketchOnline'));



// additional pages
const HandmadeRakhiOnline = lazy(() => import('./HandmadeRakhiOnline'));
const DiyProducts = lazy(() => import('./DiyProducts'));





const AboutUs = lazy(() => import('./AboutUs'));
function Index(props) {
	return (
		<BrowserRouter basename="/">
			<Suspense fallback={<div></div>}>
				<Routes>
					{/* <Route path='/error-404' element={<ErrorPage />} /> */}
					<Route path="/terms-and-condition" element={<TermsAndCondition />} />
					<Route path="/refund-concellation" element={<RefundAndCancellation />} />
					<Route path="/shipping-and-delivery" element={<ShippingAndDelivery />} />

					{/* <Route path='/under-construction' element={<UnderConstruction />} /> */}
					{/* <Route path='/coming-soon' element={<ComingSoon />} /> */}
					{/* <Route path='/index-2' element={<Home2 />} /> */}
					<Route element={<MainLayout />} >
						<Route path='/' exact element={<Home />} />
						<Route path='/about-us' exact element={<AboutUs />} />
						<Route path='/my-profile' exact element={<MyProfile />} />
						<Route path="/student_profile" element={<Student_profile />} />
						<Route path="/student-profile/:studentId" element={<StudentProfile />} />
						<Route path="/saved-address" element={<SavedAddress />} />
						<Route path='/faq' exact element={<Faq />} />
						<Route path='/impact' exact element={<Impact />} />
						<Route path='/help-desk' exact element={<HelpDesk />} />
						<Route path='/pricing' exact element={<Pricing />} />
						<Route path='/privacy-policy' exact element={<PrivacyPolicy />} />
						<Route path='/books-grid-view' exact element={<LegacyShopRedirect target="/student-creations-sidebar" />} />
						<Route path='/student-creations' exact element={<LegacyShopRedirect target="/student-creations-sidebar" />} />
						<Route path='/books-list' exact element={<Navigate to="/student-creations-list" replace />} />
						<Route path='/student-creations-list' exact element={<ShopList />} />
						<Route path='/books-grid-view-sidebar' exact element={<Navigate to="/student-creations-sidebar" replace />} />
						<Route path='/shop' exact element={<BooksGridViewSidebar />} />
						<Route path='/books-list-view-sidebar' exact element={<Navigate to="/student-creations-list-sidebar" replace />} />
						<Route path='/student-creations-list-sidebar' exact element={<BooksListViewSidebar />} />
						<Route path='/shop-cart' exact element={<ShopCart />} />
						<Route path='/my-orders' exact element={<MyOrders />} />
						<Route path='/wishlist' exact element={<Wishlist />} />
						<Route path='/shop-login' exact element={<Login />} />
						<Route path='/shop-registration' exact element={<Registration />} />
						<Route path='/shop-verify-otp' exact element={<OtpVerification />} />
						<Route path='/email-otp-verify' exact element={<EmailOtpVerification />} />
						<Route path='/shop-checkout' exact element={<ShopCheckout />} />
						<Route path='/books-detail/:artworkId' exact element={<LegacyDetailRedirect />} />
						{/* <Route path='/student-creations/:artworkId' exact element={<ShopDetail />} /> */}
						<Route path='/:slug/p/:id' exact element={<ShopDetail />} />
						<Route path='/student-list' exact element={<AllStudents />} />
						<Route path='/books-detail' exact element={<LegacyShopRedirect target="/student-creations-sidebar" />} />
						<Route path='/blog-grid' exact element={<BlogGrid />} />
						<Route path='/blog-large-sidebar' exact element={<BlogLargeSidebar />} />
						<Route path='/blog-list-sidebar' exact element={<BlogListSidebar />} />
						<Route path='/blog-detail' exact element={<BlogDetail />} />
						<Route path='/contact-us' exact element={<ContactUs />} />
						<Route path='/student-entrepreneurship-pune' exact element={<StudentEntrepreneurshipPune />} />
						<Route path='/student-creativity-entrepreneurship-in-delhi' exact element={<StudentCreativityEntrepreneurshipDelhi />} />
						<Route path='/student-entrepreneurship-bengaluru' exact element={<StudentEntrepreneurshipBengaluru />} />
						<Route path='/student-entrepreneurship-usa' exact element={<StudentEntrepreneurshipUSA />} />
						<Route path='/student-entrepreneurship-uk' exact element={<StudentEntrepreneurshipUK />} />
						<Route path='/student-entrepreneurship-canada' exact element={<StudentEntrepreneurshipCanada />} />
						<Route path='/student-entrepreneurship-australia' exact element={<StudentEntrepreneurshipAustralia />} />
						<Route path='/student-entrepreneurship-germany' exact element={<StudentEntrepreneurshipGermany />} />
						<Route path='/student-entrepreneurship-india' exact element={<StudentEntrepreneurshipIndia />} />
						<Route path='/all-testimonials' exact element={<AllTestimonials />} />
						<Route path='/all-blogs' exact element={<AllBlogs />} />
						<Route path='/buy-handmade-paintings-online-student-art' exact element={<BuyHandmadePaintingsOnlineStudentArt />} />
						<Route path='/luxury-digital-art-prints-for-modern-home-and-office-decor' exact element={<LuxuryDigitalArtPrintsForModernHomeAndOfficeDecor />} />
						<Route path='/handmade-wall-art-for-living-room' exact element={<HandmadeWallArtForLivingRoom />} />
						<Route path='/handmade-canvas-paintings' exact element={<HandmadeCanvasPaintingsForModernHomes />} />
						<Route path='/luxury-handmade-sculptures-home-decor' exact element={<LuxuryHandmadeSculpturesHomeDecor />} />
						<Route path='/handmade-home-decor' exact element={<HandmadeHomeDecor />} />
						<Route path='/handmade-lifestyle-products' exact element={<HandmadeLifestyleProducts />} />
						<Route path='/handmade-apparel-online' exact element={<HandmadeApparelOnline />} />
						<Route path='/handmade-drawings' exact element={<HandmadeDrawings />} />
						<Route path='/handmade-drinkware-online' exact element={<HandmadeDrinkwareOnline />} />
						<Route path='/anime-art' exact element={<AnimeArt />} />
						<Route path='/art-for-home-decor' exact element={<ArtForHomeDecor />} />
						<Route path='/my_following' exact element={<FollowList />} />
						<Route path='/artist-stories' exact element={<YouTubeGallery />} />
						<Route path='/handmade-festival-decor' exact element={<HandmadeFestivalDecor />} />
						<Route path='/custom-request/:id' exact element={<CustomRequestForm />} />
						<Route path='/my-requests' exact element={<MyRequests />} />
						<Route path='/handmade-gifts-online-for-every-occasion' exact element={<HandmadeGiftsOnlineForEveryOccasion />} />
						<Route path='/luxury-printable-wall-art' exact element={<LuxuryPrintableWallArt />} />
						<Route path='/modern-digital-artwork-decor' exact element={<ModernDigitalArtworkDecor />} />
						<Route path='/personalized-gift-items' exact element={<PersonalizedGiftItems />} />
						<Route path='/modern-canvas-wall-art-stylish-interiors' exact element={<ModernCanvasWallArtStylishInteriors />} />
						<Route path='/handmade-home-decor-ideas' exact element={<HandmadeHomeDecorIdeas />} />
						<Route path='/unique-home-and-living-products' exact element={<UniqueHomeAndLivingProducts />} />
						<Route path='/modern-sculptures-for-home-decor' exact element={<ModernSculpturesForHomeDecor />} />
						<Route path='/best-handmade-gifts-in-pune' exact element={<BestHandmadeSiftsInPune />} />
						<Route path='/buy-handmade-gifts-online-in-pune' exact element={<BuyHandmadeGiftsOnlineInPune />} />
						<Route path='/accounts' exact element={<Accounts />} />
						<Route path='/top-rated-handmade-gift-shop-in-pune' exact element={<TopRatedHandmadeGiftShopInPune />} />
						<Route path='/affordable-handmade-gifts-in-pune-home-delivery' exact element={<AffordableHandmadeGiftsInPuneHomeDelivery />} />
						<Route path='/exclusive-handmade-gifts-in-pune-online' exact element={<ExclusiveHandmadeGiftsInPuneOnline />} />
						<Route path='/buy-handmade-products-created-by-students-in-delhi' exact element={<BuyhandmadeProductsCreatedByStudentsInDelhi />} />
						<Route path='/buy-handmade-products-created-by-students-delhi' exact element={<BuyHandmadeProductsbyDelhiStudentsOnline />} />
						<Route path='/buy-unique-handmade-products-student-entrepreneurs-delhi' exact element={<BuyUniqueHandmadeProductsStudentEntrepreneursDelhi />} />
						<Route path='/handcrafted-gifts-delhi' exact element={<HandcraftedGiftsDelhi />} />
						<Route path='/student-handmade-art-gifts-decor-delhi' exact element={<StudentHandmadeArtGiftsDecorDelhi />} />
						<Route path='/handmade-products-online-shopping-india' exact element={<HandmadeProductsOnlineShoppingIndia />} />
						<Route path='/discover-handmade-products-online' exact element={<DiscoverBeautifulHandmadeProductsOnline />} />
						<Route path='/handmade-purchase-helps-student-entrepreneurs' exact element={<HandmadePurchaseHelpsStudentEntrepreneurs />} />
						<Route path='/handmade-store-online' exact element={<HandmadeStoreOnline />} />
						<Route path='/affordable-modern-sculptures-home-decor' exact element={<AffordableModernSculpturesforStylishHomeDecor />} />
						<Route path='/buy-handmade-products-in-pune' exact element={<BuyHandmadeProductsinPune />} />
						<Route path='/printable-wall-art-bedroom-decoration' exact element={<PrintableWallArtBedroomDecoration />} />
						<Route path='/buy-premium-handmade-gifts-in-pune' exact element={<BuyPremiumHandmadeGiftsinPune />} />
						<Route path='/handmade-products-in-pune' exact element={<HandmadeProductsinPune />} />
						<Route path='/eco-friendly-handmade-products-pune' exact element={<EcoFriendlyHandmadeProductsPune />} />
						<Route path='/buy-handmade-decorative-items-pune' exact element={<BuyHandmadeDecorativeItemsPune />} />
						<Route path='/beautiful-handmade-products-pune' exact element={<BeautifulHandmadeProductsPune />} />
						<Route path='/handmade-home-decor-products-pune' exact element={<HandmadeHomeDecorProductsPune />} />
						<Route path='/authentic-handmade-products-online-pune' exact element={<AuthenticHandmadeProductsOnlinePune />} />
						<Route path='/shop-handmade-products-online-pune' exact element={<ShopHandmadeProductsOnlinePune />} />
						<Route path='/best-place-buy-handmade-products-pune' exact element={<BestPlaceBuyHandmadeProductsPune />} />
						<Route path='/buy-handmade-kundan-rakhi-online' exact element={<BuyHandmadeKundanRakhiOnline />} />
						<Route path='/anime-art-handmade-paintings-wall-art-student-creations' exact element={<AnimeArtHandmadePaintingsWallArtStudentCreations />} />
						<Route path='/gifting-stationery-online-india' exact element={<GiftingStationeryOnlineIndia />} />
						<Route path='/handmade-painting-germany-near-me' exact element={<HandmadePaintingGermanyNearMe />} />
						<Route path='/sketch-drawing-online' exact element={<SketchDrawingOnline />} />
						<Route path='/best-bags-accessories-women-men-everyday-use' exact element={<BestBagsAccessoriesWomenMenEverydayUse />} />
						<Route path='/buy-premium-healthy-water-bottle' exact element={<BuyPremiumHealthyWaterBottle />} />
						<Route path='/sketch-artist-in-pune-handmade-portrait-from-photo' exact element={<SketchArtistInPuneHandmadePortraitFromPhoto />} />
						<Route path='/best-sketch-artist-in-bengaluru-custom-handmade-portraits' exact element={<BestSketchArtistInBengaluruCustomHandmadePortraits />} />
						<Route path='/handmade-portrait-from-photo-in-delhi' exact element={<HandmadePortraitFromPhotoInDelhi />} />
						<Route path='/hire-sketch-artist-usa-handmade-portraits' exact element={<HireSketchArtistUsaHandmadePortraits />} />
						<Route path='/buy-handmade-products-canada-online' exact element={<BuyHandmadeProductsCanadaOnline />} />
						<Route path='/handmade-products-in-canada' exact element={<HandmadeProductsInCanada />} />
						<Route path='/buy-handmade-products-in-germany-online' exact element={<BuyHandmadeProductsInGermanyOnline />} />
						<Route path='/shop-handmade-indian-products-online-in-germany' exact element={<ShopHandmadeIndianProductsOnlineInGermany />} />
						<Route path='/discover-handmade-products-germany' exact element={<DiscoverHandmadeProductsGermany />} />
						<Route path='/where-to-buy-handmade-products-germany' exact element={<WhereToBuyHandmadeProductsGermany />} />
						<Route path='/best-handmade-products-germany' exact element={<BestHandmadeProductsGermany />} />
						<Route path='/digital-art-germany' exact element={<DigitalArtGermany />} />
						<Route path='/unique-handmade-gift-ideas-for-birthdays' exact element={<UniqueHandmadeGiftIdeasForBirthdays />} />
						<Route path='/australian-handmade-products' exact element={<AustralianHandmadeProducts />} />
						<Route path='/best-australian-handmade-products-online' exact element={<BestAustralianHandmadeProductsOnline />} />
						<Route path='/buy-australian-handmade-products-online' exact element={<BuyAustralianHandmadeProductsOnline />} />
						<Route path='/shop-australian-handmade-products-online' exact element={<ShopAustralianHandmadeProductsOnline />} />
						<Route path='/discover-australian-handmade-products-online' exact element={<DiscoverAustralianHandmadeProductsOnline />} />
						<Route path='/buy-handmade-products-in-bengaluru' exact element={<BuyHandmadeProductsInBengaluru />} />
						<Route path='/unique-digital-art-bengaluru-online' exact element={<UniqueDigitalArtBengaluruOnline />} />
						<Route path='/bengaluru-handcrafted-shopping' exact element={<BengaluruHandcraftedShopping />} />
						<Route path='/unique-digital-art-bengaluru' exact element={<UniqueDigitalArtBengaluru />} />
						<Route path='/festival-decor-bengaluru' exact element={<FestivalDecorBengaluru />} />
						<Route path='/bengaluru-festival-decor-shopping' exact element={<BengaluruFestivalDecorShopping />} />
						<Route path='/diy-handmade-products-in-bengaluru' exact element={<DiyHandmadeProductsInBengaluru />} />
						<Route path='/diy-handmade-crafts-bengaluru-online' exact element={<DiyHandmadeCraftsBengaluruOnline />} />
						<Route path='/custom-personalized-products-bengaluru' exact element={<CustomPersonalizedProductsBengaluru />} />
						<Route path='/personalized-gifts-bengaluru-online' exact element={<PersonalizedGiftsBengaluruOnline />} />
						<Route path='/canvas-paintings-bengaluru-online' exact element={<CanvasPaintingsBengaluruOnline />} />
						<Route path='/handmade-bags-accessories-bengaluru' exact element={<HandmadeBagsAccessoriesbengaluru />} />
						<Route path='/canvas-paintings-in-bengaluru' exact element={<CanvasPaintingsInBengaluru />} />
						<Route path='/bengaluru-handmade-bags-accessories-online' exact element={<BengaluruHandmadeBagsAccessoriesOnline />} />
						<Route path='/buy-art-home-bengaluru-online' exact element={<BuyArtHomeBengaluruOnline />} />
						<Route path='/shop-art-home-bengaluru' exact element={<ShopArtHomeBengaluru />} />
						<Route path='/buy-handmade-apparel-bengaluru-online' exact element={<BuyHandmadeApparelBengaluruOnline />} />
						<Route path='/shop-handmade-apparel-bengaluru' exact element={<ShopHandmadeApparelBengaluru />} />
						<Route path='/buy-anime-art-bengaluru-online' exact element={<BuyAnimeArtBengaluruOnline />} />
						<Route path='/shop-anime-art-bengaluru' exact element={<ShopAnimeArtBengaluru />} />
						<Route path='/buy-handmade-sketch-online' exact element={<BuyHandmadeSketchOnline />} />



						{/* additonal pages */}
						<Route path='/handmade-rakhi-online' exact element={<HandmadeRakhiOnline />} />
						<Route path='/diy-products' exact element={<DiyProducts />} />
					</Route>
				</Routes>
			</Suspense>
			<ScrollToTop />
			<ScrollToTop2 className="styles_scroll-to-top__2A70v  fas fa-arrow-up scroltop" smooth />
		</BrowserRouter>
	)
}

function MainLayout() {
	const location = useLocation();

	// Optional: Hide bottom nav on specific pages like checkout, login, etc.
	const hideBottomNavPaths = [''];
	const shouldShowBottomNav = !hideBottomNavPaths.includes(location.pathname);
	return (
		<div className="page-wraper">
			<Header />
			<main id="main-content">
				<Outlet />
			</main>
			<Footer footerChange="style-1" logoImage={logo} />

			{/* Bottom Navigation - Mobile only */}
			{shouldShowBottomNav && <BottomNav />}
		</div>
	)

};

function LegacyDetailRedirect() {
	const { artworkId } = useParams();
	return <Navigate to={`/student-creations/${artworkId}`} replace />;
}

function LegacyShopRedirect({ target }) {
	const location = useLocation();
	return <Navigate to={`${target}${location.search || ''}`} replace />;
}
export default Index;
